export default __webpack_public_path__ + "static/media/TIPOPRADO.0571babc.png";